import React, {Component} from "react";
import {t, Trans} from '@lingui/macro';
import {withI18n} from "@lingui/react";
import {connect} from 'react-redux';
import {Button, Col, Form, Input, message, Row} from "antd";
import Drawer from 'bukku/components/Ant/Drawer';
import PasswordRules from '../../../rules/password';
import UserActions from 'bukku/redux/User/actions';

const {
    updateUserPassword,
} = UserActions;

class UserPasswordView extends Component {
    formRef = React.createRef();
    componentDidUpdate(prevProps) {
        const {
            open,
            userPasswordUpdateState,
            closeDrawer,
        } = this.props;

        // On open
        if (open && !prevProps.open)
            this.onPageLoad();

        if (
            userPasswordUpdateState === 'success' &&
            prevProps.userPasswordUpdateState === 'request'
        )
            closeDrawer();
    }

    onPageLoad = () => {
        //
    };

    compareToFirstPassword = (rule, value) => {
        if (value && value !== this.formRef.current.getFieldValue('password'))
            return Promise.reject(new Error("The passwords are not the same."));
        return Promise.resolve();
    };

    // Normalise data for comparison.
    normalizeData = data => ({
        current_password: data.current_password || null,
        password: data.password || null,
        password_confirmation: data.password_confirmation || null,
    });

    // Prepare form data based on current data, excluding lists (items & term items)
    prepareFormData = () => this.formRef.current.getFieldsValue();

    onCloseDrawer = () => {
        const {
            closeDrawer,
        } = this.props;

        closeDrawer();
    };

    onSubmit = () => {
        this.formRef.current.validateFields().then(() => {
            this.doSubmit();
        },
        ).catch(e => {
            console.log(e);
            message.warning(t`Please check the fields highlighted in red.`);
            return false;
        });
    };

    doSubmit = () => {
        const { updateUserPassword } = this.props;
        const formData = this.normalizeData(this.prepareFormData());

        updateUserPassword(formData);
    };

    getDrawerFooter = () => {
        const {
            isPushing,
        } = this.props;

        return (
            <React.Fragment>
                <Button
                    onClick={this.onCloseDrawer}
                >
                    <Trans>Cancel</Trans>
                </Button>
                <Button
                    loading={isPushing}
                    onClick={this.onSubmit}
                    type="primary"
                    htmlType="submit"
                >
                    <Trans>Submit</Trans>
                </Button>
            </React.Fragment>
        );
    };

    render() {
        const {
            open,
        } = this.props;

        return (
            <Drawer
                title={<Trans>Change Password</Trans>}
                closable
                onClose={this.onCloseDrawer}
                open={open}
                destroyOnClose
                footer={this.getDrawerFooter()}
                onClick={e => e.stopPropagation()}
            >
                <Form layout="vertical" ref={this.formRef}>
                    <Row
                        type="flex"
                    >
                        <Col span={24}>
                            <Form.Item
                                label={<Trans>Current Password</Trans>}
                                name="current_password"
                                rules={PasswordRules()}
                            >
                                <Input type="password" placeholder={t`Current Password`} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row
                        type="flex"
                    >
                        <Col span={24}>
                            <Form.Item
                                label={<Trans>New Password</Trans>}
                                name="password"
                                rules={[
                                    ...PasswordRules(),
                                ]}
                            >
                                <Input type="password" placeholder={t`New Password`} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row
                        type="flex"
                    >
                        <Col span={24}>
                            <Form.Item
                                label={<Trans>Confirm Password</Trans>}
                                name="password_confirmation"
                                rules={[
                                    { validator: this.compareToFirstPassword },
                                    ...PasswordRules(),
                                ]}
                            >
                                <Input type="password" placeholder={t`Confirm Password`} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Button
                        onClick={e => this.onSubmit(e)}
                        type="primary"
                        htmlType="submit"
                        style={{ display: 'none' }}
                    />
                </Form>
            </Drawer>
        );
    }
}
export default connect(state => ({
    isPushing: state.App.isPushing,
    userPasswordUpdateState: state.User.userPasswordUpdateState,
}), {
    updateUserPassword,
})(withI18n()(UserPasswordView));
